import { render, staticRenderFns } from "./wkRemoteSelect.vue?vue&type=template&id=4bf4f352&scoped=true"
import script from "./wkRemoteSelect.vue?vue&type=script&lang=js"
export * from "./wkRemoteSelect.vue?vue&type=script&lang=js"
import style0 from "./wkRemoteSelect.vue?vue&type=style&index=0&id=4bf4f352&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf4f352",
  null
  
)

export default component.exports